import React, { Component } from 'react';
import { NumericFormat } from 'react-number-format';
import '../contents/css/decimal-input.css';

export default class DecimalInput extends Component {
   render() {
      return (
         <NumericFormat
            className='form-control decimal-input right-align'
            format={'#,##0.00'}
            defaultValue={this.props.defaultValue}
            onValueChange={this.props.onChange}
            // onValueChange={(values) => {
            //    if (this.props.onChange) {
            //       let value =
            //          values.value === null || values.value === undefined
            //             ? null
            //             : values.value / this.getMultiplicador(this.decimalPlaces);

            //       let formattedValue =
            //          value === null || value === undefined ? null : numberToString(value, 0, 6, this.props.lang);
            //       this.props.onChange({
            //          value: value,
            //          floatValue: value,
            //          formattedValue: formattedValue,
            //       });
            //    }
            // }}
            style={this.props.style}
            name={this.props.name}
            id={this.props.id}
            key={this.props.key}
            ref={this.props.ref}
            allowNegative={this.props.allowNegative === false ? false : true}
            decimalScale={this.props.decimalPlaces}
         />
      );
   }
}
